<template>
  <form class="lp-contact-form lu-stack" novalidate :aria-busy="loading" @submit.prevent="submit">
    <UiFormField id="contact-email" :label="$t('publicSite.email')" :error="errors.email" required v-slot="field">
      <UiInput :id="field.id" v-model="email" type="email" name="email" autocomplete="email" dir="ltr" :required="field.required" :invalid="field.invalid" :aria-describedby="field.describedby" :disabled="loading" />
    </UiFormField>
    <UiFormField id="contact-message" :label="$t('publicSite.message')" :error="errors.message" required v-slot="field">
      <UiTextarea :id="field.id" v-model="message" name="message" :rows="5" :required="field.required" :invalid="field.invalid" :aria-describedby="field.describedby" :disabled="loading" />
    </UiFormField>
    <UiAlert v-if="feedback" :tone="tone" :message="feedback" />
    <UiButton type="submit" :loading="loading">{{ $t('publicSite.sendMessage') }}<UiIcon name="arrow" class="lu-directional" /></UiButton>
  </form>
</template>
<script>
import axios from 'axios';
import { UiFormField, UiInput, UiTextarea, UiAlert, UiButton, UiIcon } from '@/components/ui';
import { textValue } from './content';
export default {
  name: 'ContactForm', components: { UiFormField, UiInput, UiTextarea, UiAlert, UiButton, UiIcon },
  data: () => ({ email: '', message: '', errors: {}, loading: false, feedback: '', tone: 'danger' }),
  methods: {
    async submit() {
      if (this.loading) return;
      this.errors = {}; this.feedback = ''; this.tone = 'danger';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email.trim())) this.errors.email = this.$t('publicSite.validEmail');
      if (!this.message.trim()) this.errors.message = this.$t('publicSite.requiredMessage');
      if (Object.keys(this.errors).length) { this.focusError(); return; }
      this.loading = true;
      try {
        const response = await axios.post('/contact_us', { email: this.email, message: this.message }, { headers: { 'Accept-Language': this.$i18n.locale } });
        if (response?.data?.status === true || response?.data?.status === 1) {
          this.tone = 'success'; this.feedback = textValue(response.data.message) || this.$t('publicSite.messageSent');
          this.email = ''; this.message = '';
        } else { this.feedback = textValue(response?.data?.message) || this.$t('publicSite.sendError'); }
      } catch (error) {
        this.feedback = textValue(error?.response?.data?.message) || this.$t('publicSite.sendError');
        for (const key of ['email', 'message']) {
          const value = error?.response?.data?.errors?.[key];
          const detail = textValue(Array.isArray(value) ? value[0] : value);
          if (detail) this.errors[key] = detail;
        }
      } finally { this.loading = false; if (Object.keys(this.errors).length) this.focusError(); }
    },
    focusError() { this.$nextTick(() => document.getElementById(this.errors.email ? 'contact-email' : 'contact-message')?.focus()); }
  }
};
</script>
